import { render, staticRenderFns } from "./Shippingmethod.vue?vue&type=template&id=0cf57b44"
import script from "./Shippingmethod.vue?vue&type=script&lang=js"
export * from "./Shippingmethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf57b44')) {
      api.createRecord('0cf57b44', component.options)
    } else {
      api.reload('0cf57b44', component.options)
    }
    module.hot.accept("./Shippingmethod.vue?vue&type=template&id=0cf57b44", function () {
      api.rerender('0cf57b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vendor/firegroup/fire-core-formgenerator/src/assets/vue/frontend/elements/Shippingmethod.vue"
export default component.exports